import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pi pi-eye"
}
const _hoisted_2 = {
  key: 1,
  class: "pi pi-eye-slash"
}

import Button from 'primevue/button';

import { useHiddenInputs } from '../composables/useHiddenInputs';
import { useCurrentView } from '../composables/useCurrentView';


export default /*@__PURE__*/_defineComponent({
  __name: 'HideInputsButton',
  setup(__props) {

const { isHiddenInputs, toggleHiddenInputs } = useHiddenInputs();
const { currentView } = useCurrentView();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    severity: "secondary",
    text: "",
    icon: "",
    onClick: _unref(toggleHiddenInputs)
  }, {
    default: _withCtx(() => [
      (!_unref(isHiddenInputs))
        ? (_openBlock(), _createElementBlock("i", _hoisted_1))
        : (_openBlock(), _createElementBlock("i", _hoisted_2)),
      _createElementVNode("span", null, " (" + _toDisplayString(_unref(currentView)?.items.filter((item) => item.is_hidden)?.length) + ") ", 1)
    ]),
    _: 1
  }, 8, ["onClick"]))
}
}

})